import axiosGatweayApi from './axiosGatwayApi'

class SecondaryPayloadApi {
    static getSecondaryPayload() {
        let requestUrl = '/inkandToner/secondaryPayload';
        return axiosGatweayApi.get(requestUrl).then(response => {
            return response;
        }).catch(error => {
            return error;
        });
    }
}

export default SecondaryPayloadApi;  